// 81数理凶吉数据
// 参考：完整版八十一数理吉凶详解 - 姓名学81个数理含义详细解析

export const NUMBERS_FORTUNE = {
  1: { 
    type: '吉', 
    name: '太极之数', 
    meaning: '太极之数，万物开泰，生发无穷，利禄亨通。',
    description: '首领运，智勇双全，意志坚定，千挫不挠，步伐踏实，能成就大业的运格。'
  },
  2: { 
    type: '凶', 
    name: '两仪之数', 
    meaning: '两仪之数，混沌未开，进退保守，志望难达。',
    description: '分离破败的衰弱之数，精神不安，无所适从。'
  },
  3: { 
    type: '吉', 
    name: '三才之数', 
    meaning: '三才之数，天地人和，大事大业，繁荣昌隆。',
    description: '智勇双全，意志坚定，千挫不挠，脚步踏实，能成就大业。'
  },
  4: { 
    type: '凶', 
    name: '四象之数', 
    meaning: '四象之数，待于生发，万事慎重，不具营谋。',
    description: '万事终局的衰弱之数，破败死亡，非有毅力，难望成功。'
  },
  5: { 
    type: '吉', 
    name: '五行之数', 
    meaning: '五行俱权，循环相生，圆通畅达，福祉无穷。',
    description: '阴阳和合、精神愉快、荣誉达利、一门兴隆。'
  },
  6: { 
    type: '吉', 
    name: '六爻之数', 
    meaning: '六爻之数，发展变化，天赋美德，吉祥安泰。',
    description: '天德地祥俱备，福庆甚厚，家势盛大，万宝朝宗。'
  },
  7: { 
    type: '吉', 
    name: '七政之数', 
    meaning: '七政之数，精悍严谨，天赋之力，吉星照耀。',
    description: '刚毅果断勇往直前的进取数，精力充沛，排除万难。'
  },
  8: { 
    type: '半吉', 
    name: '八卦之数', 
    meaning: '八卦之数，乾坎艮震，巽离坤兑，无穷无尽。',
    description: '意志如铁石，富于进取的气概，能努力达到目的。'
  },
  9: { 
    type: '凶', 
    name: '大成之数', 
    meaning: '大成之数，蕴涵凶险，或成或败，难以把握。',
    description: '浮沉不定，凶吉难分，其运就如开矿探险。'
  },
  10: { 
    type: '凶', 
    name: '终结之数', 
    meaning: '终结之数，雪暗飘零，偶或有成，回顾茫然。',
    description: '万事终局充满损耗，晦暗之象，缺乏实力。'
  },
  11: { 
    type: '吉', 
    name: '旱苗逢雨', 
    meaning: '万物更新，调顺发达，恢弘泽世，繁荣富贵。',
    description: '挽回家运的春成育数，顺调发达，稳健着实。'
  },
  12: { 
    type: '凶', 
    name: '掘井无泉', 
    meaning: '无理之数，发展薄弱，虽生不足，难酬志向。',
    description: '家庭缘薄，孤独遭难，谋事不达，悲惨不测。'
  },
  13: { 
    type: '吉', 
    name: '春日牡丹', 
    meaning: '才艺多能，智谋奇略，忍柔当事，鸣奏大功。',
    description: '智勇超群的大成功数，充满智慧是其特点。'
  },
  14: { 
    type: '凶', 
    name: '破兆', 
    meaning: '家庭缘薄，孤独遭难，谋事不达，悲惨不测。',
    description: '沦落天涯失意烦闷数，家庭缘薄，多破兆。'
  },
  15: { 
    type: '大吉', 
    name: '福寿', 
    meaning: '福寿圆满，富贵荣誉，涵养雅量，德高望重。',
    description: '最大好运，福寿圆满之象，顺和、雅量。'
  },
  16: { 
    type: '大吉', 
    name: '厚重', 
    meaning: '厚重载德，安富尊荣，财官双美，功成名就。',
    description: '反凶化吉象，得助，可成大业，富贵发达。'
  },
  17: { 
    type: '半吉', 
    name: '刚强', 
    meaning: '权威刚强，突破万难，如能容忍，必获成功。',
    description: '突破万难的刚柔兼备数，权威刚强，有己无人。'
  },
  18: { 
    type: '半吉', 
    name: '铁镜重磨', 
    meaning: '权威显达，博得名利，且养柔德，功成名就。',
    description: '有志竟成的内外有运数，一旦立志必排除万难。'
  },
  19: { 
    type: '凶', 
    name: '多难', 
    meaning: '风云蔽日，辛苦重来，虽有智谋，万事挫折。',
    description: '风云蔽日的辛苦重来数，虽有智谋，万事挫折。'
  },
  20: { 
    type: '凶', 
    name: '屋下藏金', 
    meaning: '非业破运，灾难重重，进退维谷，万事难成。',
    description: '物将坏之象，破败衰亡之数，具有短命之意。'
  },
  21: { 
    type: '大吉', 
    name: '明月中天', 
    meaning: '光风霁月，万物确立，官运亨通，大搏名利。',
    description: '明月照光，独立权威数，有首领之资质。'
  },
  22: { 
    type: '凶', 
    name: '秋草逢霜', 
    meaning: '秋草逢霜，困难疾弱，虽出豪杰，人生波折。',
    description: '薄弱无力，百事不如意数，志望难达。'
  },
  23: { 
    type: '大吉', 
    name: '壮丽', 
    meaning: '旭日东升，壮丽壮观，权威旺盛，功名荣达。',
    description: '旭日东升发育旺盛数，伟大的领导运。'
  },
  24: { 
    type: '大吉', 
    name: '掘藏得金', 
    meaning: '家门余庆，金钱丰盈，白手成家，财源广进。',
    description: '家门余庆的金钱丰盈数，才略智谋出众。'
  },
  25: { 
    type: '半吉', 
    name: '荣俊', 
    meaning: '资性英敏，才能奇特，克服傲慢，尚可成功。',
    description: '英俊刚毅资性聪敏数，有独特的才能。'
  },
  26: { 
    type: '凶', 
    name: '变怪', 
    meaning: '变怪之谜，英雄豪杰，波澜重叠，而奏大功。',
    description: '变怪奇异的豪侠数，波澜重叠，变怪奇异。'
  },
  27: { 
    type: '凶', 
    name: '增长', 
    meaning: '欲望无止，自我强烈，多受毁谤，尚可成功。',
    description: '欲望无止境，自信心过强，不容他人言语。'
  },
  28: { 
    type: '凶', 
    name: '阔水浮萍', 
    meaning: '遭难之数，豪杰气概，四海漂泊，终世浮躁。',
    description: '如萍在水，家亲缘薄，离群独处。'
  },
  29: { 
    type: '吉', 
    name: '智谋', 
    meaning: '智谋优秀，财力归集，名闻海内，成就大业。',
    description: '智谋兼备，欲望难足数，不满于现状。'
  },
  30: { 
    type: '半吉', 
    name: '非运', 
    meaning: '沉浮不定，凶吉难变，若明若暗，大成大败。',
    description: '一成一败，绝处逢生数，沉浮不定。'
  },
  31: { 
    type: '大吉', 
    name: '春日花开', 
    meaning: '智勇得志，博得名利，统领众人，繁荣富贵。',
    description: '智勇德智俱备，可享清福数，意志坚固。'
  },
  32: { 
    type: '大吉', 
    name: '宝马金鞍', 
    meaning: '侥幸多望，贵人得助，财帛如裕，繁荣至上。',
    description: '权贵显达的意外惠泽数，性格温和。'
  },
  33: { 
    type: '大吉', 
    name: '旭日升天', 
    meaning: '旭日升天，鸾凤相会，名闻天下，隆昌至极。',
    description: '家门隆昌的意外惠泽数，德智兼备，白手成功。'
  },
  34: { 
    type: '凶', 
    name: '破家', 
    meaning: '破家之身，见识短小，辛苦遭逢，灾祸至极。',
    description: '破家亡身的见识短小数，经历艰辛，难成大业。'
  },
  35: { 
    type: '大吉', 
    name: '高楼望月', 
    meaning: '温和平静，智达通畅，文昌技艺，奏功洋洋。',
    description: '温和平静的优雅发展数，智勇兼备，可成大业。'
  },
  36: { 
    type: '半吉', 
    name: '波澜重叠', 
    meaning: '波澜重叠，沉浮万状，侠肝义胆，舍己成仁。',
    description: '波澜重叠，沉浮万状的英雄运格，侠肝义胆。'
  },
  37: { 
    type: '大吉', 
    name: '猛虎出林', 
    meaning: '权威显达，热诚忠信，宜着雅量，终身荣富。',
    description: '权威显达，热诚忠信的吉人天相数，德高望重。'
  },
  38: { 
    type: '半吉', 
    name: '磨铁成针', 
    meaning: '意志薄弱，刻意经营，才识不凡，技艺有成。',
    description: '磨铁成针，刻意经营的技艺成功数，意志薄弱。'
  },
  39: { 
    type: '大吉', 
    name: '富贵荣华', 
    meaning: '富贵荣华，财帛丰盈，暗藏险象，德泽四方。',
    description: '富贵荣华，财帛丰盈的变化无穷数，德泽四方。'
  },
  40: { 
    type: '凶', 
    name: '退安', 
    meaning: '智谋胆力，冒险投机，沉浮不定，退保平安。',
    description: '智谋胆力，冒险投机的谨慎保安数，退保平安。'
  },
  41: { 
    type: '大吉', 
    name: '有德', 
    meaning: '纯阳独秀，德高望重，和顺畅达，博得名利。此数为最大好运数。',
    description: '纯阳独秀，德高望重的盛德数，博得名利。此数为最大好运数。'
  },
  42: { 
    type: '凶', 
    name: '寒蝉在柳', 
    meaning: '博识多能，精通世情，如能专心，尚可成功。',
    description: '博识多能，精通世情的薄弱散漫数，缺乏专心。'
  },
  43: { 
    type: '凶', 
    name: '散财破产', 
    meaning: '散财破产，诸事不遂，虽有智谋，财来财去。',
    description: '散财破产，诸事不遂的邪途散财数，虽有智谋。'
  },
  44: { 
    type: '凶', 
    name: '烦闷', 
    meaning: '破家亡身，暗藏惨淡，事不如意，乱世怪杰。',
    description: '破家亡身，暗藏惨淡的力量有限数，事不如意。'
  },
  45: { 
    type: '大吉', 
    name: '顺风', 
    meaning: '新生泰和，顺风扬帆，智谋经纬，富贵繁荣。',
    description: '新生泰和，顺风扬帆的新生泰和数，富贵繁荣。'
  },
  46: { 
    type: '凶', 
    name: '浪里淘金', 
    meaning: '载宝沉舟，浪里淘金，大难尝尽，大功有成。',
    description: '载宝沉舟，浪里淘金的须眉难展数，大难尝尽。'
  },
  47: { 
    type: '大吉', 
    name: '点石成金', 
    meaning: '花开之象，万事如意，祯祥吉庆，天赋幸福。',
    description: '花开之象，万事如意的权威进取数，天赋幸福。'
  },
  48: { 
    type: '大吉', 
    name: '古松立鹤', 
    meaning: '智谋兼备，德量荣达，威望成师，洋洋大观。',
    description: '智谋兼备，德量荣达的苍松立鹤数，洋洋大观。'
  },
  49: { 
    type: '半吉', 
    name: '转变', 
    meaning: '吉临则吉，凶来则凶，转凶为吉，配好三才。',
    description: '吉临则吉，凶来则凶的吉凶难分数，配好三才。'
  },
  50: { 
    type: '半吉', 
    name: '小舟入海', 
    meaning: '一成一败，吉凶参半，先得庇荫，后遭凄惨。',
    description: '一成一败，吉凶参半的吉凶参半数，先荫后惨。'
  },
  51: { 
    type: '半吉', 
    name: '沉浮', 
    meaning: '盛衰交加，波澜重叠，如能慎始，必获成功。',
    description: '盛衰交加，波澜重叠的盛衰相伴数，慎始获成功。'
  },
  52: { 
    type: '大吉', 
    name: '达眼', 
    meaning: '卓识达眼，先见之明，智谋超群，名利双收。',
    description: '卓识达眼，先见之明的先见之明数，名利双收。'
  },
  53: { 
    type: '凶', 
    name: '曲卷难星', 
    meaning: '外祥内患，外祸内安，先富后贫，先贫后富。',
    description: '外祥内患，外祸内安的忧愁困苦数，盛衰参半。'
  },
  54: { 
    type: '凶', 
    name: '石上栽花', 
    meaning: '石上栽花，难得有活，忧闷烦来，辛惨不绝。',
    description: '石上栽花，难得有活的多难悲运数，忧闷烦来。'
  },
  55: { 
    type: '半吉', 
    name: '善恶', 
    meaning: '善善得恶，恶恶得善，吉到极限，反生凶险。',
    description: '善恶共济，获救有望的外祥内苦数，吉凶无常。'
  },
  56: { 
    type: '凶', 
    name: '浪里行舟', 
    meaning: '历尽艰辛，四周障碍，万事龃龌，做事难成。',
    description: '历尽艰辛，四周障碍的浪里行舟数，万事龃龌。'
  },
  57: { 
    type: '大吉', 
    name: '日照春松', 
    meaning: '寒雪青松，夜莺吟春，必遭一过，繁荣白事。',
    description: '寒雪青松，夜莺吟春的寒雪青松数，春来开花。'
  },
  58: { 
    type: '半吉', 
    name: '晚行遇月', 
    meaning: '沉浮多端，先苦后甜，宽宏扬名，富贵繁荣。',
    description: '沉浮多端，先苦后甜的晚行遇月数，富贵繁荣。'
  },
  59: { 
    type: '凶', 
    name: '寒蝉悲风', 
    meaning: '寒蝉悲风，意志衰退，缺乏忍耐，苦难不休。',
    description: '寒蝉悲风，意志衰退的寒蝉悲风数，苦难不休。'
  },
  60: { 
    type: '凶', 
    name: '无谋', 
    meaning: '无谋之人，漂泊不定，晦暝暗黑，动摇不安。',
    description: '无谋之人，漂泊不定的黑暗无光数，动摇不安。'
  },
  61: { 
    type: '大吉', 
    name: '牡丹芙蓉', 
    meaning: '牡丹芙蓉，花开富贵，名利双收，定享天赋。',
    description: '牡丹芙蓉，花开富贵的名利双收数，定享天赋。'
  },
  62: { 
    type: '凶', 
    name: '衰败', 
    meaning: '衰败之象，内外不和，志望难达，灾祸频来。',
    description: '衰败之象，内外不和的衰败离散数，志望难达。'
  },
  63: { 
    type: '大吉', 
    name: '舟归平海', 
    meaning: '富贵荣华，身心安泰，雨露惠泽，万事亨通。',
    description: '富贵荣华，身心安泰的富贵平安数，万事亨通。'
  },
  64: { 
    type: '凶', 
    name: '非命', 
    meaning: '骨肉分离，孤独悲愁，难得心安，做事不成。',
    description: '骨肉分离，孤独悲愁的骨肉分离数，做事不成。'
  },
  65: { 
    type: '大吉', 
    name: '巨流归海', 
    meaning: '天长地久，家运隆昌，福寿绵长，事事成就。',
    description: '天长地久，家运隆昌的富贵长寿数，事事成就。'
  },
  66: { 
    type: '凶', 
    name: '岩头步马', 
    meaning: '进退维谷，艰难不堪，等待时机，一跃而起。',
    description: '进退维谷，艰难不堪的岩头步马数，等待时机。'
  },
  67: { 
    type: '大吉', 
    name: '顺风通达', 
    meaning: '天赋幸运，四通八达，家道繁昌，富贵东来。',
    description: '天赋幸运，四通八达的通达畅通数，富贵东来。'
  },
  68: { 
    type: '大吉', 
    name: '顺风吹帆', 
    meaning: '智虑周密，集众信达，发明能智，拓展昂进。',
    description: '智虑周密，集众信达的顺风吹帆数，拓展昂进。'
  },
  69: { 
    type: '凶', 
    name: '非业', 
    meaning: '非业非力，精神迫滞，灾害交至，遍偿痛苦。',
    description: '非业非力，精神迫滞的坐立不安数，灾害交至。'
  },
  70: { 
    type: '凶', 
    name: '残菊逢霜', 
    meaning: '残菊逢霜，寂寞无碍，惨淡忧愁，晚景凄凉。',
    description: '残菊逢霜，寂寞无光的残菊逢霜数，晚景凄凉。'
  },
  71: { 
    type: '半吉', 
    name: '石上金花', 
    meaning: '石上金花，内心劳苦，贯彻始终，定可昌隆。',
    description: '石上金花，内心劳苦的石上金花数，贯彻始终。'
  },
  72: { 
    type: '半吉', 
    name: '劳苦', 
    meaning: '荣苦相伴，阴云覆月，外表吉祥，内实凶祸。',
    description: '荣苦相伴，阴云覆月的先甜后苦数，外祥内凶。'
  },
  73: { 
    type: '半吉', 
    name: '无勇', 
    meaning: '盛衰交加，徒有高志，天王福祉，终世平安。',
    description: '盛衰交加，徒有高志的志高力微数，终世平安。'
  },
  74: { 
    type: '凶', 
    name: '残菊经霜', 
    meaning: '残菊经霜，秋叶寂寞，无能无智，辛苦繁多。',
    description: '残菊经霜，秋叶寂寞的残菊经霜数，辛苦繁多。'
  },
  75: { 
    type: '凶', 
    name: '退守', 
    meaning: '退守保吉，发迹甚迟，虽有吉象，无谋难成。',
    description: '退守保吉，发迹甚迟的退守保吉数，无谋难成。'
  },
  76: { 
    type: '凶', 
    name: '离散', 
    meaning: '倾覆离散，骨肉分离，内外不和，虽劳无功。',
    description: '倾覆离散，骨肉分离的倾覆离散数，虽劳无功。'
  },
  77: { 
    type: '半吉', 
    name: '半吉', 
    meaning: '家庭有悦，半吉半凶，能获援护，陷落不幸。',
    description: '家庭有悦，半吉半凶的家庭有悦数，能获援护。'
  },
  78: { 
    type: '凶', 
    name: '晚苦', 
    meaning: '祸福参半，先天智能，中年发达，晚景困苦。',
    description: '祸福参半，先天智能的祸福参半数，晚景困苦。'
  },
  79: { 
    type: '凶', 
    name: '云头望月', 
    meaning: '云头望月，身疲力尽，穷迫不伸，精神不定。',
    description: '云头望月，身疲力尽的云头望月数，精神不定。'
  },
  80: { 
    type: '凶', 
    name: '遁吉', 
    meaning: '辛苦不绝，早入隐遁，安心立命，化凶转吉。',
    description: '辛苦不绝，早入隐遁的遁世离俗数，化凶转吉。'
  },
  81: { 
    type: '大吉', 
    name: '万物回春', 
    meaning: '最吉之数，还本归元，吉祥重叠，富贵尊荣。',
    description: '最吉之数，还本归元的万物回春数，富贵尊荣。'
  }
}

// 数理吉凶简化分类
export const FORTUNE_TYPES = {
  大吉: [15, 16, 21, 23, 24, 31, 32, 33, 35, 37, 39, 41, 45, 47, 48, 52, 57, 61, 63, 65, 67, 68, 81],
  吉: [1, 3, 5, 6, 7, 11, 13, 29],
  半吉: [8, 17, 18, 25, 30, 36, 38, 49, 50, 51, 55, 58, 71, 72, 73, 77],
  凶: [2, 4, 9, 10, 12, 14, 19, 20, 22, 26, 27, 28, 34, 40, 42, 43, 44, 46, 53, 54, 56, 59, 60, 62, 64, 66, 69, 70, 74, 75, 76, 78, 79, 80]
}

// 获取数理信息
export const getNumberFortune = (number) => {
  const num = parseInt(number)
  if (num < 1 || num > 81) return null
  return NUMBERS_FORTUNE[num] || { type: '未知', name: `数理${num}`, meaning: '暂无数据', description: '暂无数据' }
}

// 判断数理吉凶
export const isLuckyNumber = (number) => {
  const num = parseInt(number)
  return FORTUNE_TYPES.大吉.includes(num) || FORTUNE_TYPES.吉.includes(num)
}

// 判断数理类型
export const getFortuneType = (number) => {
  const num = parseInt(number)
  if (FORTUNE_TYPES.大吉.includes(num)) return '大吉'
  if (FORTUNE_TYPES.吉.includes(num)) return '吉'
  if (FORTUNE_TYPES.半吉.includes(num)) return '半吉'
  if (FORTUNE_TYPES.凶.includes(num)) return '凶'
  return '未知'
} 

// 按类型分类的数字（用于快速查找）
export const NUMBERS_BY_TYPE = FORTUNE_TYPES